// libraries
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { Button, Table, Tooltip, Typography } from 'antd';
import { CheckOutlined, CameraOutlined } from '@ant-design/icons';

// components
import { SharedTable } from '../../../shared/table';

// locales
import { txt } from '../../../../locales/i18n';

export function UnionListContentDesktop(props: any) {
	const history = useHistory();
	const location = useLocation();
	
	function renderDate(value: string): string {
		const format: string = 'ddd DD/MM-YY HH:mm';
		return moment(value).format(format);
	}

	function handleOnRow(record: Record<string, any>): Record<string, any> {
		return {
			onClick: () => {
				history.replace({ hash: String(record.id), search: location.search });
				history.push(`/unions/${record.id}`);
			},
		};
	}

	function renderCheckmark(value: number): JSX.Element | null {
		if (Boolean(value) === true) {
			return <CheckOutlined />;
		}

		return null;
	}

	function renderUser(username: string, union: Record<string, any>): JSX.Element {
		function handleNavigate(event: React.MouseEvent<HTMLElement, MouseEvent>): void {
			event.stopPropagation();
			history.push(`/users/${union.userId}`);
		}

		return (
			<Tooltip title={`${txt('global.open')} ${username}`}>
				<Button type="link" onClick={handleNavigate} className="user-cell-container">
					<Typography.Link>{username}</Typography.Link>
					<Typography.Text type="secondary">{union.userMunicipality}</Typography.Text>
				</Button>
			</Tooltip>
		);
	}

	return (
		<StyledTable rowKey="id" loading={props.loading} dataSource={props.dataSource} onRow={handleOnRow}>
			<Table.Column dataIndex="id" title="ID" width="3em" />
			<Table.Column dataIndex="title" title={txt('global.title')} width="8em" ellipsis />
			<Table.Column dataIndex="municipality" title={txt('global.municipality')} width="4em" />
			<Table.Column
				dataIndex="approved"
				title={<CheckOutlined />}
				width="2em"
				align="center"
				render={renderCheckmark}
			/>
			<Table.Column
				dataIndex="image"
				title={<CameraOutlined />}
				width="2em"
				align="center"
				render={renderCheckmark}
			/>
			<Table.Column dataIndex="universe" title={txt('global.universe')} width="4em" />
			<Table.Column dataIndex="created" title={txt('global.created')} width="6em" render={renderDate} />
			<Table.Column dataIndex="username" title={txt('global.user')} width="8em" render={renderUser} ellipsis />
		</StyledTable>
	);
}

const StyledTable = styled(SharedTable)`
	.user-cell-container {
		display: flex;
		gap: 1ch;
	}
`;
